module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/UnitsView/images/view-bg.f2bb6110.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/UnitsView/images/view-bg.png
// module id = 2801
// module chunks = 11